// extracted by mini-css-extract-plugin
module.exports = {"loaderWrapper":"list-wrapper_loaderWrapper__3QrV1","itemWrapper":"list-wrapper_itemWrapper__2XvPp"};